<template>
  <div class="voucher-statistics">
    <div class="lists-container" v-if="loaded">
      <h2 class="h1 title-primary">Active Vouchers</h2>
      <table v-if="activeArray.length > 0" class="standard-table with-lines">
        <tr>
          <th><span class="absolute-wrapper">Voucher</span></th>
          <th><span class="absolute-wrapper">Created</span></th>
          <th><span class="absolute-wrapper">Redeems</span></th>
        </tr>
        <tr v-for="voucher in activeArray" :key="voucher.id">
          <td>{{ voucher.Name }}</td>
          <td>{{ voucher.convertedTimestamp }}</td>
          <td>{{ voucher.TotalRedeems }}</td>
        </tr>
      </table>
      <div v-else>
        <h3 class="h2">You do not have any vouchers to display yet</h3>
        <p>Create a voucher box and wait for guests to redeem!</p>
        <br />
      </div>
      <h2 class="h1 title-secondary">Deleted Vouchers</h2>
      <table v-if="inactiveArray.length > 0" class="standard-table with-lines">
        <tr>
          <th><span class="absolute-wrapper">Voucher</span></th>
          <th><span class="absolute-wrapper">Created</span></th>
          <th><span class="absolute-wrapper">Redeems</span></th>
        </tr>
        <tr v-for="voucher in inactiveArray" :key="voucher.id">
          <td>{{ voucher.Name }}</td>
          <td>{{ voucher.convertedTimestamp }}</td>
          <td>{{ voucher.TotalRedeems }}</td>
        </tr>
      </table>
      <div v-else>
        <h3 class="h2">You do not have any deleted vouchers to display yet</h3>
      </div>
    </div>

    <fetching-loader displayType="displayBlock" v-else></fetching-loader>
  </div>
</template>

<script>
import FetchingLoader from "@/components/GlobalComponents/FetchingLoader";
import { firestore } from "@/firebase";
import { format } from "date-fns";

export default {
  name: "voucher-statistics",
  components: {
    FetchingLoader,
  },
  data() {
    return {
      statistics: [],
      loaded: false,
    };
  },
  methods: {
    async load() {
      const querySnapshot = await firestore
        .collection(`VoucherStatistics/${this.$hotelId}/Vouchers`)
        .get();

      this.statistics = querySnapshot.docs
        .map(function (doc) {
          return {
            ...doc.data(),
            convertedTimestamp: format(
              new Date(doc.get("CreatedAt")),
              "dd-MM-yyyy"
            ),
            id: doc.id,
          };
        })
        .sort(function (a, b) {
          return b.TotalRedeems - a.TotalRedeems;
        });

      this.loaded = true;
    },
  },
  computed: {
    activeArray() {
      return this.statistics.filter((voucher) => voucher.Active);
    },
    inactiveArray() {
      return this.statistics.filter((voucher) => !voucher.Active);
    },
  },
  created() {
    return this.load();
  },
};
</script>

<style scoped>
.title-primary {
  color: var(--primary);
}

.title-secondary {
  color: var(--secondary);
}
</style>
